// Copyright (c) StrangeBee 2024

import { Button, Space } from 'antd';
import React, { ReactElement } from 'react';

import './AlertSimilarCasesStats.scss';

interface AlertSimilarCasesStatsProps {
    similar: number;
    count: number;
    onClick: (percentage: number) => void;
}

export const AlertSimilarCasesStats = ({
    similar = 0,
    count = 0,
    onClick,
}: AlertSimilarCasesStatsProps): ReactElement => {
    const percentage = Math.floor((similar / count) * 100);

    return (
        <div className="alert-similar-cases-stats">
            {count ? (
                <>
                    <Space size="large">
                        <Button
                            className="alert-similar-cases-stats__button"
                            type="link"
                            size="small"
                            onClick={(): void => onClick(percentage)}
                        >{`${percentage}%`}</Button>
                        {`(${similar}/${count})`}
                    </Space>

                    <div className="alert-similar-cases-stats__progress">
                        <div className="alert-similar-cases-stats__similar" style={{ flex: similar }} />
                        <div className="alert-similar-cases-stats__count" style={{ flex: count - similar }} />
                    </div>
                </>
            ) : (
                'N/A'
            )}
        </div>
    );
};
